export const HamburgerIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1H15" stroke="#BABABB" stroke-width="2" stroke-linecap="round"/>
        <path d="M1 6H15" stroke="#BABABB" stroke-width="2" stroke-linecap="round"/>
        <path d="M1 11H15" stroke="#BABABB" stroke-width="2" stroke-linecap="round"/>
        </svg>
    `,
      }}
    />
  );
};
